import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PatientsService } from '../../../../../../../core/lists';
import { PatientModReviewComponent } from '../../patient-mod-review/patient-mod-review.component';
import { DatePipe } from '@angular/common';
import { BaseDataSource } from '../../../../../../../core/_base/crud';
import { ActivatedRoute } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-patient-history',
  templateUrl: './patient-history.component.html',
  styleUrls: ['./patient-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientHistoryComponent implements OnInit {
  viewLoading = false;
  dataSource: BaseDataSource;
  displayedColumns = ['name', 'relation_type_id', 'description', 'classification', 'actions'];
  noRecords: boolean;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() canvasShow;
  patientId;
  @Input() patient_id_for_task_list;

  constructor(
    private patientService: PatientsService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.patientId = this.patient_id_for_task_list ? this.patient_id_for_task_list : params.id;
      this.patientService.getPatientHistory(this.patientId).subscribe((res) => {
        if (res.data) {
          this.dataSource = res.data;
          if (res.data.length === 0) {
            this.noRecords = true;
          }
          this.cdr.detectChanges();
        }
      });
      this.displayedColumns = ['version', 'action_type', 'modified_at', 'modified_by'];
    });
  }

  async openPatientModReviewDialog(version, action_type) {
    if (action_type !== 'DEL') {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.closeOnNavigation = true;

      const patientResponse = await this.patientService
        .getPatientHistory(this.patientId, version)
        .toPromise();
      const patientHistory = patientResponse.data;
      const isUpdated = action_type === 'MOD' && patientHistory.length === 2;

      dialogConfig.width = isUpdated ? '90vw' : '45vw';
      dialogConfig.data = isUpdated
        ? [{ patient: patientHistory[1] }, { patient: patientHistory[0] }]
        : [{ patient: patientHistory[0] }];

      this.dialog.open(PatientModReviewComponent, dialogConfig);
    }
  }

  getModTime(rev_timestamp) {
    return this.datePipe.transform(new Date(rev_timestamp), 'yyyy-MM-dd hh:mm:ss');
  }
}
